import endpointMapper from './../_endpoints'
import { initSearchApp } from '../_redux/actions/searchAppsActions'
import { useDispatch } from 'react-redux'
import { useFetch } from '../_hooks/useFetch'

export const useAdvanceFilterService = () => {
  const [isFiltering, getAdvanceFilter] = useFetch()
  const dispatch = useDispatch()

  const advanceFilter = async (setFilter, phrase, tags, categories, badgeNum, order) => {
    let searchString = endpointMapper.search.get.concat(`?search=${phrase}`)

    if (tags !== null) searchString = searchString.concat(`&tags=${tags}`)
    if (categories !== null) searchString = searchString.concat(`&categories=${categories}`)
    if (badgeNum !== null) searchString = searchString.concat(`&badge=${badgeNum}`)
    if (order !== null) searchString = searchString.concat(`&order=${order}`)

    const response = await getAdvanceFilter(searchString)
    setFilter(response)
    dispatch(initSearchApp(response))
  }

  return { isFiltering, advanceFilter }
}
